<template>
  <AtomsConsumerButton
    v-if="displayType === 'back' && value === 'all'"
    type="button"
    :class="$style.backButton"
    @click="onClickTab('scene')"
  >
    <AtomsConsumerImage src="/images/icon/arrow-left-blue.svg" alt="戻る" />
    シーン別で探すに戻る
  </AtomsConsumerButton>
  <ul v-else :class="$style.listTabBar">
    <li v-for="item in list" :key="item.key" :class="$style.listTabBarItem">
      <AtomsConsumerButton
        type="button"
        :class="[$style.button, { [$style.active]: value === item.key }]"
        @click="onClickTab(item.key)"
      >
        {{ item.value }}
      </AtomsConsumerButton>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import type { ProductTabBarMode, ProductTabBarType } from "~/types/product"

type ListItem = {
  key: ProductTabBarMode
  value: string
}

defineProps<{
  list: ListItem[]
  value: string
  displayType: ProductTabBarType
}>()

const emit = defineEmits<{
  (e: "update:modelValue", modelValue: string): void
  (e: "update:onClickTab", value: ProductTabBarMode): void
}>()

const onClickTab = (value: ProductTabBarMode) => {
  emit("update:onClickTab", value)
}
</script>

<style scoped module lang="scss">
.backButton {
  margin: 20px 10px 20px;
  cursor: pointer;
  font-size: 12px;
  color: $btn-bg-primary;
  text-decoration: underline;
}

.listTabBar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  white-space: nowrap;
  overflow-x: scroll;
  flex-wrap: nowrap;
  @include md {
    padding: 2px 0;
    overflow-x: inherit;
  }
  &::-webkit-scrollbar {
    display: none;
  }
  li.listTabBarItem {
    flex: 1;
    list-style-type: none;
    border-radius: 6px;
    text-align: center;
    @include md {
      margin: 0 2px;
    }
    .button {
      display: block;
      width: 100%;
      height: 100%;
      border: none;
      padding: 20px 15px;
      color: black;
      font-size: $font-size-12;
      font-weight: normal;
      transition: all 0.2s ease;
      @include md {
        font-size: $font-size-14;
        padding: 16px 30px;
      }
      &:hover {
        background: $secondary-40;
      }
      &:focus {
        outline: none;
      }
      &.active {
        font-weight: bold;
        color: $btn-bg-primary;
        border-bottom: 2px solid $btn-bg-primary;
        @include md {
          font-weight: bold;
        }
        &:hover {
          background: white;
        }
      }
    }
  }
}
</style>
